import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        azure_devops_account_name : '',
        azure_devops_project_id   : '',
        work_item_type            : '',
        auto_resolve              : false,
        is_auto                   : false,
        feedback_type             : '',
        is_disabled               : false
    },

    isConnected: function() {
        return this.get('azure_devops_project_id') ? true : false;
    }
});